import React, { useState, useRef, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import logo from "../Assets/Website Logo 1.png";
import "./home.css";
import ExactVisionStatement from "./VisionStatement";
import Platforms from "./Platforms";
import homeegramImg from '../Assets/Image 22 1.png';
import Footer from "./Footer";
const Home = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const visionRef = useRef(null);
  const platformsRef = useRef(null);
  const location = useLocation();

  const handleScrollTo = (ref) => {
    setMenuOpen(false);
    if (ref && ref.current) {
      ref.current.scrollIntoView({ behavior: 'smooth' });
    }
  };

  useEffect(() => {
    if (location.state && location.state.scrollTo) {
      if (location.state.scrollTo === 'vision' && visionRef.current) {
        visionRef.current.scrollIntoView({ behavior: 'smooth' });
      } else if (location.state.scrollTo === 'platforms' && platformsRef.current) {
        platformsRef.current.scrollIntoView({ behavior: 'smooth' });
      }
    }
    // eslint-disable-next-line
  }, [location.state]);

  return (
    <div>
      <section className="hero-section">
        <nav className="navbars">
          <div className="logo">
            <img
              onClick={() => window.location.href = '/'}
              src={logo} // Replace with your logo URL
              alt="Homeeera Logo"
              className="logo-img"
            />
          </div>
          <button
            className={`hamburger${menuOpen ? " open" : ""}`}
            onClick={() => setMenuOpen((open) => !open)}
            aria-label="Toggle navigation menu"
          >
            <span></span>
            <span></span>
            <span></span>
          </button>
          <ul className={`nav-links${menuOpen ? " show" : ""}`}>
            <li>
              <button className="nav-btn-link" onClick={() => handleScrollTo(visionRef)}>
                Our Vision
              </button>
            </li>
            <li>
              <button className="nav-btn-link" onClick={() => handleScrollTo(platformsRef)}>
                Platforms
              </button>
            </li>
            <li>
              <Link style={{padding:0}} to="/connect" onClick={() => setMenuOpen(false)}>
                Connect Us
              </Link>
            </li>
          </ul>
        </nav>
        <div className="hero-overlay">
          <h1>Build Dreams Together<span className="platforms-dot">.</span></h1>
        </div>
      </section>
      <div ref={visionRef} id="vision-section">
        <ExactVisionStatement/>
      </div>
      <div ref={platformsRef} id="platforms-section">
        <Platforms/>
      </div>
      <img style={{width: '100%', height: '100%', marginBottom:"-6px"}} src={homeegramImg} alt="Homeegram" className="homeegram-img" />
      <Footer/>
    </div>
  );
};

export default Home;
